// RefName: Change Email*
export const ContentIDConstants = {
  Question: 0,
  Tooltip1: 1,
};
